import React from 'react';
import { trackPixelEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
};
export function CtaButton({
  children,
  href = '#offer',
  className = ''
}: CtaButtonProps) {
  const handleClick = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: 'The Pharma-Masterclave',
      value: 27,
      currency: 'USD'
    });
  };
  return <a href={href} onClick={handleClick} className={`inline-flex w-full items-center justify-center rounded-xl bg-trust px-8 py-5 text-center text-base font-extrabold uppercase tracking-wide text-white shadow-lg shadow-trust/25 transition-transform duration-150 hover:-translate-y-0.5 hover:bg-trust-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-trust/40 sm:w-auto sm:text-lg ${className}`} style={{
    width: '244px',
    height: '88px'
  }} data-id="element-29" data-mp="qjimbydj5c57">
      {children}
    </a>;
}